package features.attendance.domain

data class AttendanceSettings(
    val defaultStartTime: String = "08:00",
    val defaultEndTime: String = "17:00",
    val requireShift: Boolean = false
)
